<h2 mat-dialog-title>Add Event</h2>
<mat-dialog-content>
    <form
        [formGroup]="formGroup"
        (ngSubmit)="onSubmit()">
        <mat-form-field>
            <mat-label>Title</mat-label>
            <input
                matInput
                formControlName="title"
                required />
        </mat-form-field>
        <mat-form-field>
            <mat-label>Description</mat-label>
            <input
                matInput
                formControlName="description"
                required />
        </mat-form-field>
        <mat-form-field>
            <input type="color" 
                matInput 
                formControlName="color">
        </mat-form-field>
        @if (data) {
            <p><strong>Date:</strong> {{ data.date }}</p>
        }
        <mat-dialog-actions>
            <button
                mat-button
                type="button"
                (click)="onCloseClick()">
                Cancel
            </button>
            <button
                mat-button
                type="submit"
                color="primary">
                Save
            </button>
        </mat-dialog-actions>
    </form>
</mat-dialog-content>
